import "core-js/modules/es6.regexp.split.js";

var parseHash = hash => hash.split('&').reduce((acc, item) => {
  var currentAcc = acc;
  var parts = item.split('=');
  [, currentAcc[parts[0]]] = parts;
  return currentAcc;
}, {});

export default parseHash;